// TopBar — pebble brand, ⌘K search pill, live chip, copilot, bell, avatar.

import { Link, NavLink } from "react-router-dom";
import { Icon } from "@/lib/icons";
import { IconButton } from "@/components/primitives/IconButton";
import { Avatar } from "@/components/primitives/Avatar";
import { StatusDot } from "@/components/primitives/StatusDot";
import { useUiStore } from "@/store/ui";
import { useToast } from "@/components/primitives/Toast";

export function TopBar() {
  const setCommandOpen = useUiStore(s => s.setCommandOpen);
  const setNotificationsOpen = useUiStore(s => s.setNotificationsOpen);
  const toast = useToast();
  const notifCount = 3;

  return (
    <header className="lex-topbar" role="banner">
      <Link
        to="/home"
        className="lex-brand"
        aria-label="AIDAN — Automated Index for Data Asset Nomenclature"
        title="Automated Index for Data Asset Nomenclature"
      >
        <span className="lex-brand__pebble" aria-hidden="true" />
        <span className="lex-brand__words hide-mobile">
          <span className="lex-brand__name" style={{ fontFamily: "var(--font-display)", fontStyle: "italic" }}>AIDAN</span>
          <span className="lex-brand__sub">Automated Index for Data Asset Nomenclature</span>
        </span>
      </Link>

      <span className="lex-topbar__divider hide-mobile" aria-hidden="true" />

      <button
        type="button"
        className="lex-search-pill"
        aria-label="Open command palette"
        onClick={() => setCommandOpen(true)}
      >
        <Icon.Search size={16} aria-hidden="true" />
        <span className="lex-search-pill__placeholder">Search records, mappings, lineage…</span>
        <kbd className="lex-search-pill__kbd">⌘K</kbd>
      </button>

      <span className="lex-topbar__spacer" />

      <span className="lex-chip hide-mobile" data-tone="secondary" aria-label="System status: live">
        <StatusDot tone="ok" pulse size={8} />
        Live
      </span>

      <IconButton label="Open Copilot" tone="primary" onClick={() => toast("Copilot is ready — try the Dashboard suggestions", "info")}><Icon.Sparkle size={20} /></IconButton>

      <NavLink
        to="/about"
        aria-label="About AIDAN"
        title="About AIDAN"
        className={({ isActive }) => "lex-icon-btn" + (isActive ? " is-active" : "")}
        data-active={undefined}
      >
        <Icon.Info size={20} />
      </NavLink>

      <span className="lex-bell">
        <IconButton label="Notifications" onClick={() => setNotificationsOpen(true)}>
          <Icon.Bell size={20} />
        </IconButton>
        {notifCount > 0 ? <span className="lex-bell__badge" aria-hidden="true">{notifCount}</span> : null}
      </span>

      <Avatar name="Olivia Park" size={32} tone="primary" />
    </header>
  );
}

export default TopBar;
